export interface IManageAssignmentsNew {
  Status: string;
  Email: string;
  Id: number;
}
export interface IManageAssignments {
  digitalCopySent: boolean;
  emailAddress: string;
  id: string;
  isDownloaded: boolean;
  isOpened: boolean;
}

export default {};
